var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.locales),function(ref,index){
var locale = ref.locale;
return _c('span',{key:locale},[(index !== 0)?_c('span',[_vm._v("|")]):_vm._e(),_c('v-btn',{class:{ 'text--primary': locale === _vm.currentLocale },attrs:{"icon":""},on:{"click":function($event){return _vm.setLocale(locale)}}},[_vm._v(" "+_vm._s(locale)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }